/* cc-shoppable-video.js — Cologne Curators creator videos, shoppable.
   Opens a card's video in a modal alongside its product form. No dependencies.
   Progressive enhancement: without this file every card is still a working
   link to the product, so nothing is lost if the asset fails to load. The buy
   form likewise degrades to a normal POST to /cart when fetch is unavailable
   or the request fails -- the shopper always ends up with the item.
   A11y: role=dialog, focus trap, Esc, scroll lock, focus restored on close. */
(function () {
  var FOCUSABLE = 'a[href],button:not([disabled]),select,input,textarea,video[controls],[tabindex]:not([tabindex="-1"])';

  function init(root) {
    if (root.__ccShopVid) return;
    root.__ccShopVid = true;

    var modal = root.querySelector('[data-shopvid-modal]');
    var video = root.querySelector('[data-shopvid-video]');
    var side = root.querySelector('[data-shopvid-side]');
    if (!modal || !video || !side) return;

    var lastFocus = null;

    function close() {
      if (modal.hidden) return;
      try { video.pause(); } catch (e) {}
      video.removeAttribute('src');
      // Force the element to drop the decoded stream rather than keep buffering.
      try { video.load(); } catch (e) {}
      side.innerHTML = '';
      modal.hidden = true;
      root.classList.remove('is-open');
      document.documentElement.classList.remove('cc-shopvid-lock');
      document.removeEventListener('keydown', onKey, true);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
      lastFocus = null;
    }

    function onKey(e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); return; }
      if (e.key !== 'Tab') return;
      var items = [].slice.call(modal.querySelectorAll(FOCUSABLE)).filter(function (el) {
        return el.offsetParent !== null || el === document.activeElement;
      });
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }

    // Add to cart without leaving the modal. Uses the theme's own contract --
    // POST /cart/add.js with bundled `cart-ajax` section rendering, then dispatch
    // the bubbling `ajaxProduct:added` that Expanse's drawer and cart count
    // already listen for (see assets/overlay.quick-add.js). Anything unexpected
    // falls through to a native submit rather than stranding the shopper.
    function wireForm(form) {
      if (!window.fetch || !window.FormData) return; // native POST to /cart
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var btn = form.querySelector('.cc-shopvid__cta');
        var status = side.querySelector('[data-shopvid-status]');
        var root_ = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        if (btn) { btn.classList.add('btn--loading'); btn.disabled = true; }
        if (status) { status.textContent = ''; status.classList.remove('is-error'); }

        var body = new FormData(form);
        body.append('sections', 'cart-ajax');

        fetch(root_ + 'cart/add.js', {
          method: 'POST',
          body: body,
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' }
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
          .then(function (res) {
            if (btn) { btn.classList.remove('btn--loading'); btn.disabled = false; }

            // Shopify reports a rejected add (sold out, limit) as 422 with a description.
            if (!res.ok || res.data.status === 422 || res.data.status === 'bad_request') {
              if (status) {
                status.textContent = res.data.description || res.data.message || 'Could not add this to your cart.';
                status.classList.add('is-error');
              }
              return;
            }

            if (status) {
              status.textContent = root.getAttribute('data-added-label') || 'Added to your cart.';
              var link = document.createElement('a');
              link.href = root.getAttribute('data-cart-url') || (root_ + 'cart');
              link.className = 'cc-shopvid__cartlink';
              link.textContent = root.getAttribute('data-view-cart-label') || 'View cart';
              status.appendChild(document.createTextNode(' '));
              status.appendChild(link);
            }

            // Let the theme update its cart count / drawer.
            form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
              bubbles: true,
              detail: { product: res.data, addToCartBtn: btn }
            }));
          })
          .catch(function () {
            // Network or parse failure: submit for real rather than swallow it.
            if (btn) { btn.classList.remove('btn--loading'); btn.disabled = false; }
            form.submit();
          });
      });
    }

    function open(card) {
      var src = card.getAttribute('data-video');
      if (!src) return;

      lastFocus = card;
      side.innerHTML = '';

      var tpl = card.parentNode.querySelector('[data-shopvid-panel]');
      if (tpl && tpl.content) {
        side.appendChild(tpl.content.cloneNode(true));
        // The panel is re-cloned on every open, so the form is wired per-open.
        var form = side.querySelector('.cc-shopvid__form');
        if (form) wireForm(form);
      }

      video.setAttribute('src', src);
      video.setAttribute('aria-label', card.getAttribute('data-title') || 'Product video');
      modal.hidden = false;
      root.classList.add('is-open');
      document.documentElement.classList.add('cc-shopvid-lock');
      document.addEventListener('keydown', onKey, true);

      // The user asked for this video by clicking, so playing it is expected —
      // but never fight an autoplay block or a reduced-motion preference.
      var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!reduce) {
        var p = video.play();
        if (p && p.catch) p.catch(function () {});
      }

      var target = modal.querySelector('.cc-shopvid__close');
      if (target) target.focus();
    }

    root.addEventListener('click', function (e) {
      var closer = e.target.closest ? e.target.closest('[data-shopvid-close]') : null;
      if (closer && modal.contains(closer)) { e.preventDefault(); close(); return; }

      var card = e.target.closest ? e.target.closest('[data-shopvid-open]') : null;
      if (card && root.contains(card)) { e.preventDefault(); open(card); }
    });
  }

  function boot(scope) {
    var nodes = (scope || document).querySelectorAll('[data-cc-shopvid]');
    [].forEach.call(nodes, init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  // Theme-editor lifecycle: sections are re-rendered on every setting change.
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var r = e.target.querySelector ? e.target.querySelector('[data-cc-shopvid]') : null;
    if (r) { r.__ccShopVid = false; }
    document.documentElement.classList.remove('cc-shopvid-lock');
  });
})();
